import ContactPageIcon from "@mui/icons-material/ContactPage";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DataGrid, { Column, Pager, Paging } from "devextreme-react/data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContactsListByFolder } from "../../redux/dev_chetan_api_helper";
import { handleOpenContactForClientModal } from "../../redux/docuSlice";
import CloseIcon from '@mui/icons-material/Close';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import {
  Rtk_Save_selectedContact,
  RtkEditContactModalReducer,
} from "../../redux/adityaReducer";
import { portalUser } from "../../redux/AxiosInstance";
import { toast } from "react-toastify";
import { ad_GetAllContactsByCCode_Json } from "../../redux/dev_aditya_action";

const pageSizes = [10, 25, 50, 100];

export default function ClientContactGrid() {
  const dispatch = useDispatch();
  const { selectedContactRtk } = useSelector((state) => state.aditya);
  const { rtk_getAllContactsPubUser } = useSelector((state) => state.aditya);
  const [activeBtn, setActiveBtn] = useState(2);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFolder, setSelectedFolder] = React.useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [makeAdminModalOpen, setMakeAdminModalOpen] = useState(false);
  const [inactiveContact, setInactiveContact] = useState(
    selectedContactRtk?.CActive
  );
  const Email = localStorage.getItem("EmailClient");
  const password = localStorage.getItem("passwordClient");
  const accId = localStorage.getItem("accIdClient");
  console.log(selectedContact, "selectedcontactrtk");

  const [contacts, setContacts] = useState(
    selectedContactRtk || {
      accId: accId,
      username: Email,
      sPassword: password,
      Salutation: selectedContactRtk.Salutation || "",
      FirstName: selectedContactRtk.FirstName || "",
      LastName: selectedContactRtk.LastName || "",
      Add1: selectedContactRtk.Add1 || "",
      Add2: selectedContactRtk.Add2 || "",
      Add3: selectedContactRtk.Add3 || "",
      Town: selectedContactRtk.Town || "",
      PostCode: selectedContactRtk.PostCode || "",
      Country: selectedContactRtk.Country || "",
      ManagerName: selectedContactRtk.ManagerName || "",
      Role: selectedContactRtk.Role || "",
      Tel: selectedContactRtk.Tel || "",
      Mobile: selectedContactRtk.Mobile || "",
      CCode: selectedContactRtk["CCode"] || "",
      maincontact: "False",
      greeting: selectedContactRtk.greeting || "",
      Contactemail: selectedContactRtk.EMailId || "",
      AssignedManager: selectedContactRtk.AssignedManager || 0,
      emailupdate: selectedContactRtk.EMailId || "",
      CActive: selectedContactRtk.CActive || "",
      note: selectedContactRtk.note || "",
    }
  );

  useEffect(() => {
    if (selectedContactRtk) {
      setContacts({
        accId: localStorage.getItem("accIdClient") || "",
        username: localStorage.getItem("EmailClient") || "",
        sPassword: localStorage.getItem("passwordClient") || "",
        Salutation: selectedContactRtk.Salutation || "",
        FirstName: selectedContactRtk.FirstName || "",
        LastName: selectedContactRtk.LastName || "",
        Add1: selectedContactRtk.Add1 || "",
        Add2: selectedContactRtk.Add2 || "",
        Add3: selectedContactRtk.Add3 || "",
        Town: selectedContactRtk.Town || "",
        PostCode: selectedContactRtk.PostCode || "",
        Country: selectedContactRtk.Country || "",
        ManagerName: selectedContactRtk.ManagerName || "",
        Role: selectedContactRtk.Role || "",
        Tel: selectedContactRtk.Tel || "",
        Mobile: selectedContactRtk.Mobile || "",
        CCode: selectedContactRtk["CCode"] || "",
        maincontact: "False",
        greeting: selectedContactRtk.greeting || "",
        Contactemail: selectedContactRtk.EMailId || "",
        AssignedManager: selectedContactRtk.AssignedManager || 0,
        emailupdate: selectedContactRtk.EMailId || "",
        CActive: selectedContactRtk.CActive || "",
        note: selectedContactRtk.note || "",
      });
    }
  }, [selectedContactRtk]);

  useEffect(() => {
    setInactiveContact(selectedContactRtk?.CActive);
  }, [selectedContactRtk]);

  const realContacts =
    rtk_getAllContactsPubUser?.filter((item)=> item?.EMailId !== Email)?.map((contact) => ({
      ...contact,
      displayedFields: {
        CCode: contact.CCode || "",
        Salutation: contact.Salutation || "",
        FirstName: contact.FirstName || "",
        LastName: contact.LastName || "",
        EMailId: contact.EMailId || "",
        Add1: contact.Add1 || "",
        Add2: contact.Add2 || "",
        Add3: contact.Add3 || "",
        PostCode: contact.PostCode || "",
        Town: contact.Town || "",
        Country: contact.Country || "",
        Mobile: contact.Mobile || "",
        Tel: contact.Tel || "",
      },
    })) || [];

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    if (selectedFolder) {
      dispatch(getContactsListByFolder(selectedFolder, () => {}));
    }
  }, [selectedFolder]);

  const handleClickOpen = () => {
    dispatch(handleOpenContactForClientModal(true));
  };

  const handleMenuOpen = (event, contact) => {
    setAnchorEl(event.currentTarget);
    dispatch(Rtk_Save_selectedContact(contact));
    setSelectedContact(contact);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedContact(null);
  };

  const handleMakeAdminClick = () => {
    setAnchorEl(null);
    setMakeAdminModalOpen(true);
    handleMenuClose();
  };

  const handleCloseMakeAdminModal = () => {
    setMakeAdminModalOpen(false);
  };

  const ActionColumn = ({ data }) => (
    <IconButton onClick={(event) => handleMenuOpen(event, data)}>
      <MoreVertIcon />
    </IconButton>
  );

  const handleUpdateContact = () => {
    setAnchorEl(null);
    dispatch(RtkEditContactModalReducer(true));
  };

  const handleMakeAdminOrInactiveContact = async (updateType) => {
    try {
      const updatedContacts = {
        ...contacts,
        ...(updateType === "MakeAdmin" && { maincontact: "True" }),
        ...(updateType === "CActive" && {
          CActive: contacts.CActive === "Yes" ? "No" : "Yes",
        }),
      };

      const response = await portalUser.post(
        "UpdateContact_Json",
        updatedContacts
      );
      console.log(response?.data?.d, "Response of update");

      if (response?.data?.d === "Success") {
        setAnchorEl(null)
        toast.success(
          `${
            updateType === "MakeAdmin"
              ? "Contact set as Admin"
              : "Contact status updated"
          } successfully`
        );
        handleCloseMakeAdminModal();
        const payloadForGetContacts = {
          accId: accId,
          username: Email,
          sPassword: password,
          CCode:
            JSON.parse(localStorage.getItem("selectedoriginator"))
              ?.OriginatorNo || "",
        };
        dispatch(ad_GetAllContactsByCCode_Json(payloadForGetContacts));
      } else {
        toast.error(`Failed to update contact! ${response?.data?.d}`);
      }
    } catch (e) {
      console.log(e, "Error in updateContact");
      toast.error("Failed to update contact");
    }
  };

  return (
    <Box mt={3} className="relative" style={{ top: "35px" }}>

      <Box className="search-area">
        <Box className="d-flex align-items-center justify-content-end flex-wrap">
          <Box className="search-input me-2">
            <SearchIcon />
            <TextField
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
              fullWidth
              label="Search"
              size="small"
            />
          </Box>

          <Button
            variant="outlined"
            className="btn-blue mb-0"
            onClick={handleClickOpen}
            startIcon={<ContactPageIcon />}
          >
            Create Contact
          </Button>
        </Box>
      </Box>

      {activeBtn === 2 && (
        <DataGrid
          dataSource={realContacts}
          allowColumnReordering={true}
          rowAlternationEnabled={true}
          showBorders={true}
          className="table-grid table-height custom-table"
          width="100%"
          columnAutoWidth={true}
        >
          <Column dataField="CCode" caption="Originator No" dataType="string" />
          <Column
            dataField="Salutation"
            caption="Salutation"
            dataType="string"
          />
          <Column
            dataField="FirstName"
            caption="First Name"
            dataType="string"
          />
          <Column dataField="LastName" caption="Last Name" dataType="string" />
          <Column dataField="EMailId" caption="E-Mail" dataType="string" />
          <Column dataField="Add1" caption="Address 1" dataType="string" />
          <Column dataField="Add2" caption="Address 2" dataType="string" />
          <Column dataField="Add3" caption="Address 3" dataType="string" />
          <Column dataField="PostCode" caption="Post Code" dataType="string" />
          <Column dataField="Town" caption="Town" dataType="string" />
          <Column dataField="Country" caption="Country" dataType="string" />
          <Column
            dataField="Mobile"
            caption="Mobile Number"
            dataType="string"
          />
          <Column dataField="Tel" caption="Telephone" dataType="string" />
          <Column caption="Action" cellRender={ActionColumn} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={10} />
        </DataGrid>
      )}

      <Menu
       className="custom-dropdown"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleMakeAdminClick}>Make Admin</MenuItem>
        <MenuItem onClick={() => handleUpdateContact()}>
          Update Contact
        </MenuItem>
        <MenuItem onClick={() => handleMakeAdminOrInactiveContact("CActive")}>
          {inactiveContact === "Yes" ? "Inactive Contact" : "Activate Contact"}
        </MenuItem>
      </Menu>

      <Dialog open={makeAdminModalOpen} onClose={handleCloseMakeAdminModal}>
        
        <Box className="d-flex align-items-center justify-content-between modal-head">
          <Box className="clearfix">
          <DialogTitle>Make Admin</DialogTitle>
          </Box>
          <Button onClick={handleCloseMakeAdminModal} autoFocus>
            <CloseIcon />
          </Button>
        </Box>

        <DialogContent>
          <DialogContentText>
            <Typography className="font-14 poppins-sembold">
              {selectedContactRtk?.FirstName} {selectedContactRtk?.LastName}{" "}
              will be made administrator, and you will no longer be the admin
              for {selectedContactRtk?.CCode}. Do you wish to proceed?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMakeAdminModal} className="btn-red"  startIcon={<CloseIcon />}>
            
            Cancel
          </Button>
          <Button
            onClick={() => handleMakeAdminOrInactiveContact("MakeAdmin")} className="btn-blue"
            startIcon={<DoneAllIcon />}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
